import { Image } from '@mantine/core';
import React from 'react';

import virtuousLogo from 'images/zapier_brands/virtuous.png';

/** The CRM icon in the page's card headers. Decorative: the header text names the CRM. */
export const VIRTUOUS_ICON = <Image alt={''} h={'1em'} src={virtuousLogo} w={'1em'} />;
